<template>
  <span class="search-tips-info">
    <i
        class="pi pi-info-circle search-tips-icon"
        aria-label="Search tips"
        role="button"
        tabindex="0"
        @click.stop="toggle"
        @keydown.enter.prevent="toggle"
    ></i>
    <!-- appendTo body + high baseZIndex: the search boxes live inside PrimeVue
         Dialogs, whose content clips (overflow) and outranks (z-index) an
         in-place overlay — without this the panel opens invisibly. -->
    <OverlayPanel
        ref="panel"
        :dismissable="true"
        appendTo="body"
        :baseZIndex="10000"
        class="search-tips-panel"
    >
      <div class="search-tips-content">
        <div class="search-tips-title">Search tips</div>
        <div v-for="tip in tips" :key="tip.example" class="search-tips-row">
          <code>{{ tip.example }}</code>
          <span>{{ tip.text }}</span>
        </div>
      </div>
    </OverlayPanel>
  </span>
</template>

<script>
export default {
  name: "SearchTipsInfo",
  props: {
    // Defaults are the product search tips; other searches pass their own
    tips: {
      type: Array,
      default: () => [
        { example: '#AGS200', text: 'product code only' },
        { example: 'hoist + 500kg', text: 'all terms must match' },
        { example: 'AGS200', text: 'searches code, name, description, comments & supplier part no.' },
      ],
    },
  },
  methods: {
    toggle(event) {
      this.$refs.panel.toggle(event);
    },
  },
};
</script>

<style>
/* Shared layout for any "search input + tips icon" row. Lives here (once)
   instead of being copied into every component that adds the icon. */
.product-search-wrap {
  /* !important: callers style the old root (e.g. .add-product-autocomplete
     sets display:block via ::v-deep) — those rules now land on this wrapper
     and must not break the input+icon row. */
  display: flex !important;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
}

.product-search-wrap .product-search-input {
  flex: 1;
  min-width: 0;
}

.search-tips-info {
  display: inline-flex;
  align-items: center;
}

.search-tips-icon {
  cursor: pointer;
  color: #6b7280;
  font-size: 1rem;
  padding: 0 0.25rem;
}

.search-tips-icon:hover {
  color: #374151;
}

.search-tips-panel .p-overlaypanel-content {
  padding: 0.75rem 1rem;
}

.search-tips-content {
  font-size: 0.85rem;
  max-width: 260px;
}

.search-tips-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.search-tips-row {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
  margin-bottom: 0.35rem;
}

.search-tips-row:last-child {
  margin-bottom: 0;
}

.search-tips-row code {
  background: #f3f4f6;
  border-radius: 3px;
  padding: 0.1rem 0.3rem;
  white-space: nowrap;
  flex-shrink: 0;
}

.search-tips-row span {
  color: #4b5563;
}
</style>
